import { Component, OnInit } from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';

@Component({
  selector: 'eci-domestic-invoice-form',
  templateUrl: './domestic-invoice-form.component.html',
  styleUrls: ['./domestic-invoice-form.component.scss']
})
export class DomesticInvoiceFormComponent extends InvoiceTemplateBase implements OnInit {

  ngOnInit(): void {
      this.model = {
          ...this.template,
          ...this.invoice,
          customerCompany: {
              ...this.template.customerCompany,
              ...this.invoice.customerCompany
          }
      };
  }

}
